import { IPatientListVariants } from "../@types/Patient";
import { PATIENT_LIST_VARIANT } from "../constants/localStorageKeys";
import { patientListVariants } from "../constants/patientListVariants";
import { safeStorage } from "./storage";

type PatientListVariant = IPatientListVariants["variant"];

const VALID_VARIANTS: string[] = Object.values(patientListVariants);

/**
 * EN-5318. The list variant the user last viewed, as stored by PatientList.
 * Login, MFA and the 401 handler clear storage, so a clinician who goes
 * straight to a patient (search, deep link, bookmark) has no stored variant —
 * building `/patients/${variant}` from the raw value then produced
 * `/patients/null`, which matches `:patientId` and shows the 404 page.
 * Falls back to the active list whenever the value is missing or unknown.
 */
export function getStoredPatientListVariant(): PatientListVariant {
  const storedVariant = safeStorage.getItem(PATIENT_LIST_VARIANT);

  return storedVariant && VALID_VARIANTS.includes(storedVariant)
    ? (storedVariant as PatientListVariant)
    : (patientListVariants.ACTIVE as PatientListVariant);
}

export function getPatientListPath(): string {
  return `/patients/${getStoredPatientListVariant()}`;
}
